import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TravelCreditAction} from '../../shared/models/travel-credit-action';
import {TravelCreditType} from '../../shared/models/travel-credit-type';

@Component({
  selector: 'step-action-type',
  templateUrl: './step-action-type.component.html',
  styleUrls: ['./step-action-type.component.css']
})
export class StepActionTypeComponent implements OnInit {
  public actionType = '';
  constructor(private route: ActivatedRoute) {

    if (!this.route || !this.route.data) {
      return;
    }

    let self = this;
    self.route.data.subscribe(val => {
      if (val) {
        if (TravelCreditAction[val.travelCreditAction]) {
          self.actionType = val.travelCreditAction === TravelCreditAction.Add ? 'Create' : 'Edit';
        }

        if (val.travelCreditType) {
          self.actionType += ((<TravelCreditType>val.travelCreditType).id === TravelCreditType.WaiverId   ? ' Waiver' : ' Favour');
        }
      }
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/steps/step-action-type/step-action-type.component.ts